
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/overviews/[id]/[slug]",
      function () {
        return require("private-next-pages/overviews/[id]/[slug].tsx");
      }
    ]);
  